module.exports = __webpack_public_path__ + "img/icon_logo.e1ab7a97.png";